import { MARKET_TODAY_ERROR } from "../../Equity/interface/iMarketToday";
import { MARKET_TODAY, MARKET_TODAY_HIDE_ERROR, MARKET_TODAY_START_LOADER, MARKET_TODAY_STOP_LOADER, MARKET_TODAY_STREAM, } from "../interface/iMarketToday";
import { marketFutTodayStream } from "@domains/features/Markets/Futures/utils/streamingUpdate";
const initialState = {
    data: {},
    marketTodayLoader: true,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const marketToday = (state = initialState, action) => {
    switch (action.type) {
        case MARKET_TODAY:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case MARKET_TODAY_STREAM:
            return Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { marketToday: marketFutTodayStream(state.data.marketToday, action.payload.qouteStream) }) });
        case MARKET_TODAY_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case MARKET_TODAY_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case MARKET_TODAY_START_LOADER:
            return Object.assign(Object.assign({}, state), { marketTodayLoader: true });
        case MARKET_TODAY_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { marketTodayLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default marketToday;
